<template>
  <div>
    <div id="myTopnav" class="topNav bg-screen_bg">
      <div v-if="userAndCompDetail !== null" class="w-full ">
        <div class="flex justify-between items-center " v-if="!mobileView">
          
          <div class="flex card bg-white rounded-xl p-2 w-full" :class="`${!planTodayExpire && !planSomeDaysError && !showStorageErr ? 'items-center h-14' : ''} ${showStorageErr && (planTodayExpire || planSomeDaysError) ? 'h-18' : !showStorageErr && (planTodayExpire || planSomeDaysError) ? 'h-14' : 'h-14'}`">
            <div class="relative flex-1">
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                </div>
                <input 
                  v-model="searchQuery"
                  @input="handleSearch"
                  @focus="handleFocus"
                  @blur="handleBlur"
                  ref="searchInput"
                  type="text" 
                  placeholder="Global search..." 
                  class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-primary focus:border-primary"
                />
                <button
                  v-if="searchQuery"
                  @click="clearSearch"
                  type="button"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                >
                  <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div v-if="showSearchResults && searchQuery.length >= 2" 
                   @mousedown.prevent
                   @click.stop
                   class="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-96 overflow-hidden">
                <div class="p-4">
                  <div v-if="tabTitle !== null"
                    class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
                    <ul class="flex flex-wrap -mb-px">
                      <li v-for="(tab, index) in tabTitle" :key="index" class="mr-2 cursor-pointer" @click.stop="tabsSet(index)">
                        <span href="#"
                          :class="`${tab.active ? 'text-primary  border-primary' : 'border-transparent'} border-b-2 inline-block px-4 py-2 rounded-t-lg active dark:text-blue-500 dark:border-blue-500`"
                          aria-current="page">
                          <div>{{ tab.name }}</div>
                          <div>{{ tab.count }}</div>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-2 max-h-60 overflow-y-auto">
                    <div v-show="selectedName === 'Job'" >
                      <Jobs />
                    </div>
                    <div v-show="selectedName === 'Visit'">
                      <Visit />
                    </div>
                    <div v-show="selectedName === 'Lead'" >
                      <Leads />
                    </div>
                    <div v-show="selectedName === 'Invoice'">
                      <Invoices />
                    </div>
                    <div v-show="selectedName === 'Customer'">
                      <Customer />
                    </div>
                    <div v-show="selectedName === 'Payment'">
                      <Payment />
                    </div>
                    <div v-show="selectedName === 'Shift'">
                      <Shift />
                    </div>
                    <div v-show="selectedName === 'Quote'">
                      <Quotes />
                    </div>
                    <div v-show="selectedName === 'Request'">
                      <Requests />
                    </div>
                    <div v-show="selectedName === 'Task'">
                      <Tasks />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showSearchResults && searchQuery.length > 0 && searchQuery.length < 2" 
                   class="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg">
                <div class="px-4 py-2 text-gray-500">*Please enter 2 characters or more.</div>
              </div>
            </div>
            <!-- <div class="absolute -bottom-1 pl-2 heading-6 text-error" v-if="planOverError && !planTodayExpire && !planSomeDaysError" >*Your {{this.planDetaiObj.isFree ? 'Free/trial' : this.planDetaiObj.currentPlanName}} Has ended.please <router-link :to="{ name: 'plan'} " target="_blank" class="cursor-pointer text-blue-400 hover:underline">click here</router-link> to upgrade your plan to continue</div> -->
            <div class="absolute -bottom-1 pl-2 heading-6 text-error" v-if="!planOverError && planTodayExpire && !planSomeDaysError" >*Your {{this.planDetaiObj.isFree ? 'Trial is about ' : this.planDetaiObj.currentPlanName + ' plan Has'}} expire.please <router-link :to="{ name: 'plan' , query: {currentPlanId: this.planDetaiObj.planId, currencyCode: this.cCode}} " target="_blank" class="cursor-pointer text-blue-400 hover:underline">click here</router-link> to upgrade your plan to continue</div>
            <div class="absolute -bottom-1 pl-2 heading-6 text-error" v-if="!planOverError && !planTodayExpire && planSomeDaysError" >*Your {{this.planDetaiObj.isFree ? 'free trial ' : this.planDetaiObj.currentPlanName + ' plan '}} expires in {{this.diffDays}} days, please <router-link :to="{ name: 'plan' , query: {currentPlanId: this.planDetaiObj.planId, currencyCode: this.cCode}} " target="_blank" class="cursor-pointer text-blue-400 hover:underline">click here</router-link> to upgrade your plan to continue</div>
            <div :class="`${showStorageErr && (planTodayExpire || planSomeDaysError) ? '-bottom-5' : showStorageErr && (!planTodayExpire && !planSomeDaysError) ? '-bottom-1' : ''}`" class="absolute -bottom-1 pl-2 heading-6 text-error" v-if="showStorageErr" >*You have utilized 90% of your {{this.planDetaiObj.currentPlanStorage}} GB space of your current plan, please upgrade your plan or manage your space by logging into mobile app to continue</div>
          </div>
          <div class="flex gap-4 ml-4 ">
            <div class="d_icon_child">
              <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-4 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-2 w-16 h-14" @click="openSupport()">
               <i class="fa-solid fa-headset"></i>
              </div>
              <span class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">Support</span>
            </div>
            <div class="d_icon_child">
              <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-4 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-2 w-16 h-14" @click="openFeedback()">
                <i class="fa-solid fa-file-pen"></i>
               </div>
              <span class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">Send Feedback</span>
            </div>
            <!-- <div class="d_icon_child">
              <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-4 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-2 w-16 h-14" @click="openGlobalPopup()">
                <i class="fa-solid fa-magnifying-glass"></i>
               </div>
              <span class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">Global Search</span>
            </div> -->
            <div v-if="userAndCompDetail && (userAndCompDetail.isAdmin || userAndCompDetail.isOwner)" class="d_icon_child">
              <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-4 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-2 w-16 h-14" @click="redirectToPlan()">
                <i class="fa-solid fa-hand-holding-dollar"></i>
               </div>
              <span class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">Subscription</span>
            </div>
            <div class="d_icon_child">
              <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-4 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-2 w-16 h-14 relative" @click="redirectDetail()">
                <i class="fa-solid fa-user"></i>
                <span v-if="!userAndCompDetail.isEmailVerify" style="border-radius: 100%; padding-left: 6px; padding-right: 6px;" class="text-error border border-error text absolute bottom-8 right-1">
                  <i  class="fa-solid fa-exclamation"></i>
                </span>
               </div>
              <span class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">My Profile</span>
            </div>
            <div v-if="userAndCompDetail && (userAndCompDetail.isAdmin || userAndCompDetail.isOwner)" class="d_icon_child">
              <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-4 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-2 w-16 h-14" @click="goToOrgDetail()">
                <i class="fa-solid fa-house-chimney-user"></i>
               </div>
              <span class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">Organization</span>
            </div>
            <div class="d_icon_child">
              <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-3 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-2 w-16 h-14" @click="goLoginPage()">
                <i class="fa-solid fa-right-from-bracket"></i>
               </div>
              <span class="tooltiptext heading-4 bg-transparent whitespace-nowrap rounded">Log Out</span>
            </div>
          </div>
        </div>
        <div class="flex justify-between items-center overflow-auto relative" v-if="mobileView">
          <div class="flex items-center card bg-white rounded-xl p-2 h-12 sticky left-0" :class="extraSmall ? '' : 'w-full'">
            <div @click="smallViewOpenDrawer">
              <div class="heading-3 text-gray3 pr-1">
                <i class="fa-solid fa-bars"></i>
              </div>
            </div>
            <div v-if="!extraSmall" class="text-primary font-semibold text-md cursor-pointer pl-2 " @click="redirectDashboard()">{{userAndCompDetail.firstName}} {{userAndCompDetail.lastName}}</div>
          </div>
          <div class="flex gap-2 ml-2 ">
            <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-5 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-1 w-12 h-12" @click="openSupport()">
             <i class="fa-solid fa-headset"></i>
            </div>
            <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-5 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-1 w-12 h-12" @click="openFeedback()">
             <i class="fa-solid fa-file-pen"></i>
            </div>
            <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-5 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-1 w-12 h-12" @click="openGlobalPopup()">
             <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <div v-if="userAndCompDetail && (userAndCompDetail.isAdmin || userAndCompDetail.isOwner)" class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-5 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-1 w-12 h-12" @click="redirectToPlan()">
              <i class="fa-solid fa-hand-holding-dollar"></i>
            </div>
            <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-5 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-1 w-12 h-12" @click="redirectDetail()">
             <i class="fa-solid fa-user"></i>
            </div>
            <div v-if="userAndCompDetail && (userAndCompDetail.isAdmin || userAndCompDetail.isOwner)" class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-5 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-1 w-12 h-12" @click="goToOrgDetail()">
             <i class="fa-solid fa-house-chimney-user"></i>
            </div>
            <div class="flex items-center justify-center text-text2 font-bold hover:text-primary cursor-pointer heading-4 border transition delay-75 border-white hover:border-primary card bg-white rounded-xl p-1 w-12 h-12" @click="goLoginPage()">
             <i class="fa-solid fa-right-from-bracket"></i>
            </div>
          </div>
        </div>
        <div v-if="mobileView">
          <div class="pl-2 heading-6 text-error" v-if="!planOverError && planTodayExpire && !planSomeDaysError" >*Your {{this.planDetaiObj.isFree ? 'Trial is about ' : this.planDetaiObj.currentPlanName + ' plan Has'}} expire.please <router-link :to="{ name: 'plan' , query: {currentPlanId: this.planDetaiObj.planId, currencyCode: this.cCode}} " target="_blank" class="cursor-pointer text-blue-400 hover:underline">click here</router-link> to upgrade your plan to continue</div>
          <div class="pl-2 heading-6 text-error" v-if="!planOverError && !planTodayExpire && planSomeDaysError" >*Your {{this.planDetaiObj.isFree ? 'free trial ' : this.planDetaiObj.currentPlanName + ' plan '}} expires in {{this.diffDays}} days, please <router-link :to="{ name: 'plan' , query: {currentPlanId: this.planDetaiObj.planId, currencyCode: this.cCode}} " target="_blank" class="cursor-pointer text-blue-400 hover:underline">click here</router-link> to upgrade your plan to continue</div>
        </div>
      </div>
      <!-- <div class="flex card bg-white rounded-xl p-2 w-full h-14" :class="!planTodayExpire && !planSomeDaysError ? 'items-center ' : ' '">
        <div class="text-primary text-xl cursor-pointer pl-2 overFlowParaA " :class="!planTodayExpire && !planSomeDaysError ? 'font-bold ' : 'heading-4 font-semibold '" @click="redirectDashboard()">{{userAndCompDetail.firstName}} {{userAndCompDetail.lastName}}</div>
        <div class="absolute -bottom-1 pl-2 heading-6 text-error" v-if="!planOverError && planTodayExpire && !planSomeDaysError" >*Your {{this.planDetaiObj.isFree ? 'Trial is about ' : this.planDetaiObj.currentPlanName + ' plan Has'}} expire.please <router-link :to="{ name: 'plan'} " target="_blank" class="cursor-pointer text-blue-400 hover:underline">click here</router-link> to upgrade your plan to continue</div>
        <div class="absolute -bottom-1 pl-2 heading-6 text-error" v-if="!planOverError && !planTodayExpire && planSomeDaysError" >*Your {{this.planDetaiObj.isFree ? 'free trial ' : this.planDetaiObj.currentPlanName + ' plan '}} expires in {{this.diffDays}} days, please <router-link :to="{ name: 'plan'} " target="_blank" class="cursor-pointer text-blue-400 hover:underline">click here</router-link> to upgrade your plan to continue</div>
      </div> -->
    </div>
    <!-- <div id="myTopnav" class="topNav bg-screen_bg">
         <div v-if="userAndCompDetail !== null" class="w-full">
           <div class="flex justify-between items-center">
             <div class="flex items-center">
               <div @click="smallViewOpenDrawer" v-if="mobileView">
                 <div class="heading-1 text-gray3 pr-1">
                   <i class="fa-solid fa-box"></i>
                 </div>
               </div>
               <div class="text-primary font-bold text-2xl">{{userAndCompDetail.organizationName}}</div>
             </div>
             <div class="flex gap-4 items-center">
               <div @click="openGlobalPopup()" class="text-text2 font-bold hover:text-primary cursor-pointer">
                 <i class="fa-solid fa-magnifying-glass"></i>
               </div>
               <div class="text-text2 font-bold hover:text-primary cursor-pointer">
                 Clock-In-Now...
               </div>
               <div class="text-text2 font-bold hover:text-primary cursor-pointer" @click="goToOrgDetail()">
                 <i class="fa-solid fa-house-chimney-user"></i>
               </div>
               <div class="text-text2 font-bold hover:text-primary cursor-pointer">
                 <i class="fa-solid fa-bell"></i>
               </div>
               <div @click="goLoginPage()" class="text-text2 font-bold hover:text-primary cursor-pointer">
                 <i class="fa-solid fa-user-alt-slash"></i>
               </div>
             </div>
           </div>
         </div>
        </div> -->
        <div v-if="isGlobalSearch">
          <GlobalMainSearch />
        </div>
  </div>
</template>

<script>
import {removeCookies} from '@/utils/cookies'
import {FilterPermissions} from '@/utils/Permissions.js'
import deboucneMixin from '@/mixins/debounce.js'
import GlobalMainSearch from '@/View/components/globalMainSearch.vue'
import MyJobApp from '@/api/MyJobApp.js'
import Visit from '@/View/components/searchList/visits.vue';
import Jobs from '@/View/components/searchList/jobs.vue';
import Invoices from '@/View/components/searchList/invoices.vue';
import Customer from '@/View/components/searchList/customers.vue';
import Payment from '@/View/components/searchList/payments.vue';
import Shift from '@/View/components/searchList/shifts.vue';
import Quotes from '@/View/components/searchList/quotes.vue';
import Requests from '@/View/components/searchList/requests.vue';
import Tasks from '@/View/components/searchList/tasks.vue';
import Leads from '@/View/components/searchList/leads.vue';
export default {
  mixins: [deboucneMixin],
  components: {
    GlobalMainSearch,
    Jobs,
    Requests,
    Quotes,
    Shift,
    Tasks,
    Visit,
    Invoices,
    Payment,
    Customer,
    Leads
  },
  name: "TopNavbar",
  props: ['countryCode'],
  data() {
    return {
      showStorageErr: false,
      planSomeDaysError: false,
      planTodayExpire: false,
      planOverError: false,
      diffDays: 0,
      showExpireErr: false,
      showExpiredErr: false,
      planDetaiObj: null,
      userAndCompDetail: null,
      drawerIsOpen: false,
      mobileView: false,
      isGlobalSearch: false,
      extraSmall: false,
      cCode: '',
      searchQuery: '',
      showSearchResults: false,
      searchResults: [],
      searchTimeout: null,
      selectedName: 'Job',
      tabTitle: [],
      tabs: [
        { name: 'Job', active: true, count: '--', canViewPermission: FilterPermissions('job') },
        { name: 'Visit', active: false, count: '--', canViewPermission: true },
        { name: 'Lead', active: false, count: '--' , canViewPermission: FilterPermissions('lead')},
        { name: 'Invoice', active: false, count: '--' , canViewPermission: FilterPermissions('invoice')},
        { name: 'Customer', active: false, count: '--' , canViewPermission: FilterPermissions('customer')},
        { name: 'Payment', active: false, count: '--' , canViewPermission: true},
        { name: 'Shift', active: false, count: '--' , canViewPermission: FilterPermissions('shift')},
        { name: 'Quote', active: false, count: '--' , canViewPermission: FilterPermissions('quote')},
        { name: 'Request', active: false, count: '--' , canViewPermission: FilterPermissions('request')},
        { name: 'Task', active: false, count: '--' , canViewPermission: FilterPermissions('task')},
      ],
      getLeadListDebounce: null,
    };
  },
  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  mounted() {
    this.cCode = this.countryCode
    this.$root.$on("closeGlobalSearchDialog", () => {
      this.isGlobalSearch = false
      this.showSearchResults = false
      // Remove focus from search input after redirect
      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur()
      }
    });
    this.$root.$on("manageProfileIcon", () => {
      this.userAndCompDetail = JSON.parse(localStorage.getItem('jobUserInfo'))
    });
    document.body.style.overflow = 'auto'
    document.body.style = 'overflow: visible;'
    this.searchWidth = window.innerWidth - 400
    this.resizeWindowHandler()
    if (localStorage.getItem('jobUserInfo') !== null) {
      this.userAndCompDetail = JSON.parse(localStorage.getItem('jobUserInfo'))
      // console.log('organizationDetailId', this.userAndCompDetail);
    }
    this.currentPlanDetail()
    
    // Initialize tabs for search functionality
    for (let index = 0; index < this.tabs.length; index++) {
      if (this.tabs[index].canViewPermission) {
        this.tabTitle.push(this.tabs[index])
      }
    }
    if (this.tabTitle.length > 0) {
      this.tabTitle[0].active = true
      this.selectedName = this.tabTitle[0].name
    }
    
    // Add event listeners for search counts
    this.$root.$on("jobSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Job') {
          element.count = response
        }
      });
    });
    this.$root.$on("visitSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Visit') {
          element.count = response
        }
      });
    });
    this.$root.$on("leadSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Lead') {
          element.count = response
        }
      });
    });
    this.$root.$on("invoiceSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Invoice') {
          element.count = response
        }
      });
    });
    this.$root.$on("custSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Customer') {
          element.count = response
        }
      });
    });
    this.$root.$on("paymentSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Payment') {
          element.count = response
        }
      });
    });
    this.$root.$on("shiftSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Shift') {
          element.count = response
        }
      });
    });
    this.$root.$on("quotesSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Quote') {
          element.count = response
        }
      });
    });
    this.$root.$on("requestSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Request') {
          element.count = response
        }
      });
    });
    this.$root.$on("taskSearchingCount", (response) => {
      this.tabTitle.forEach(element => {
        if (element.name === 'Task') {
          element.count = response
        }
      });
    });
    
    // Initialize debounced search function
    this.getLeadListDebounce = this.debounce(function () {
      if (this.searchQuery.length >= 2) {
        this.getallCount()
        if (this.selectedName === 'Job') {
          this.$root.$emit('jobSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Visit') {
          this.$root.$emit('visitsSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Lead') {
          this.$root.$emit('leadSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Invoice') {
          this.$root.$emit('invoiceSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Customer') {
          this.$root.$emit('customerSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Payment') {
          this.$root.$emit('paymentSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Shift') {
          this.$root.$emit('shiftSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Quote') {
          this.$root.$emit('quotesSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Request') {
          this.$root.$emit('requestSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Task') {
          this.$root.$emit('taskSearchingCall', this.searchQuery)
        }
      }
    }, 500)
    
    // Add click outside handler
    document.addEventListener('click', this.handleClickOutside)
  },
  watch: {
    countryCode: {
      handler () {
        this.cCode = this.countryCode
      }
    },
    searchQuery: {
      handler () {
        if (this.searchQuery.length < 2) {
          for (let index = 0; index < this.tabTitle.length; index++) {
            this.tabTitle[index].count = '--'
          }
        }
      }
    },
    deep: true
  },
  methods: {
    openFeedback () {
      this.$router.push({name: 'Feedback'}).catch(()=>{});
    },
    openSupport () {
      this.$router.push({name: 'Support'}).catch(()=>{});
    },
    openGlobalPopup () {
      this.isGlobalSearch = true
    },
    handleSearch() {
      // Always show search results when typing
      if (this.searchQuery.length >= 2) {
        this.showSearchResults = true
      }
      this.getLeadListDebounce()
    },
    handleFocus() {
      this.showSearchResults = true
      // If there's already a search query, trigger search to show results
      if (this.searchQuery.length >= 2) {
        this.handleSearch()
      }
    },
    clearSearch () {
      this.searchQuery = ''
      this.showSearchResults = false
    },
    tabsSet(index) {
      this.tabTitle.forEach((element, i) => {
        if (index === i) {
          element.active = true
          this.selectedName = element.name
        } else {
          element.active = false
        }
      });
      if (this.searchQuery.length >= 2) {
        if (this.selectedName === 'Job') {
          this.$root.$emit('jobSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Visit') {
          this.$root.$emit('visitsSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Lead') {
          this.$root.$emit('leadSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Invoice') {
          this.$root.$emit('invoiceSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Customer') {
          this.$root.$emit('customerSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Payment') {
          this.$root.$emit('paymentSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Shift') {
          this.$root.$emit('shiftSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Quote') {
          this.$root.$emit('quotesSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Request') {
          this.$root.$emit('requestSearchingCall', this.searchQuery)
        } else if (this.selectedName === 'Task') {
          this.$root.$emit('taskSearchingCall', this.searchQuery)
        }
      }
    },
    getallCount () {
      MyJobApp.GlobalSearchCount(
        0,
        500,
        this.searchQuery,
        response => {
          for (let index = 0; index < this.tabTitle.length; index++) {
            if (this.tabTitle[index].name === 'Job') {
              this.tabTitle[index].count = response.Data.jobDataCount
            } else if (this.tabTitle[index].name === 'Visit') {
              this.tabTitle[index].count = response.Data.visitDataCount
            } else if (this.tabTitle[index].name === 'Lead') {
              this.tabTitle[index].count = response.Data.leadDataCount
            } else if (this.tabTitle[index].name === 'Invoice') {
              this.tabTitle[index].count = response.Data.invoiceDataCount
            } else if (this.tabTitle[index].name === 'Customer') {
              this.tabTitle[index].count = response.Data.customerDataCount
            } else if (this.tabTitle[index].name === 'Payment') {
              this.tabTitle[index].count = response.Data.paymentDataCount
            } else if (this.tabTitle[index].name === 'Shift') {
              this.tabTitle[index].count = response.Data.shiftDataCount
            } else if (this.tabTitle[index].name === 'Quote') {
              this.tabTitle[index].count = response.Data.quotationDataCount
            } else if (this.tabTitle[index].name === 'Request') {
              this.tabTitle[index].count = response.Data.requestDataCount
            } else if (this.tabTitle[index].name === 'Task') {
              this.tabTitle[index].count = response.Data.taskDataCount
            } 
          }
        },
        (error) => {
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
        }
      )
    },
    handleBlur() {
      // Check if the blur is happening because of clicking within the search results
      setTimeout(() => {
        const activeElement = document.activeElement
        const searchDropdown = this.$el.querySelector('.absolute.z-50')
        
        // If the active element is within the search dropdown, don't hide results
        if (searchDropdown && searchDropdown.contains(activeElement)) {
          return
        }
        
        // If we're not clicking within the search dropdown, hide results
        this.showSearchResults = false
      }, 150)
    },
    hideSearchResults() {
      this.showSearchResults = false
    },
    handleClickOutside(event) {
      const searchContainer = this.$el.querySelector('.relative.flex-1')
      if (searchContainer && !searchContainer.contains(event.target)) {
        this.showSearchResults = false
      }
    },
    redirectDashboard () {
      this.$router.push({name: 'dashboard1'}).catch(()=>{});
    },
    redirectDetail () {
      this.$router.push({ name: 'SettingEmployeesDetail', params: { empId: parseInt(this.userAndCompDetail.userDetailId) }, query: {showDelele: true}}).catch(()=>{});
    },
    goToOrgDetail () {
      this.$router.push({name: 'OrgDetail'}).catch(()=>{});
    },
    redirectToPlan () {
      this.$router.push({name: 'SubscriptionDetail'}).catch(()=>{});
    },
    goLoginPage () {
      removeCookies('jobAuthToken')
      localStorage.clear()
      this.$router.push({name: 'login'}).catch(()=>{});
      location.reload()
    },
    smallViewOpenDrawer() {
      if (this.mobileView) {
        setTimeout(() => {
          document.getElementById("sv_smySidenav").style.minWidth = "260px";
          document.getElementById("overlay").style.display = "block";
        }, 10);
      }
    },
    currentPlanDetail () {
      this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.GetCurrentPlanDetail(
        response => {
          this.planDetaiObj = response.Data !== null ? response.Data : null
          const requestDt = new Date(this.planDetaiObj.currentPlanEndOn).setHours(0, 0, 0)
          const todayDate = new Date().setHours(0, 0, 0)
          // console.log('requestDt--->()', requestDt, this.planDetaiObj.currentPlanEndOn)
          // console.log('todayDate--->()', todayDate, new Date())
          const diffTime = Math.abs(todayDate - requestDt);
          this.diffDays = Math.ceil(parseFloat((diffTime / (1000 * 3600 * 24)).toFixed(2)));
          // console.log('diffDays', this.diffDays)
          if (this.diffDays === 0) {
            this.planOverError = false
            this.planTodayExpire = true
            this.planSomeDaysError = false
            this.$root.$emit('disableAllscreen', false, this.planDetaiObj)
          } else {
            if (requestDt < todayDate) {
              this.planOverError = true
              this.planTodayExpire = false
              this.planSomeDaysError = false
              this.$root.$emit('disableAllscreen', true, this.planDetaiObj)
            } else if (this.diffDays < 7) {
                this.planOverError = false
                this.planTodayExpire = false
                this.planSomeDaysError = true
                this.$root.$emit('disableAllscreen', false, this.planDetaiObj)
              // this.showExpireErr = 
              }
          }
          let totalStorage = parseInt(this.planDetaiObj.currentPlanStorage)*1024
          let fileSizeMB = this.planDetaiObj.totalUsedStorage / (1024 ** 2)
          let totalUsedStorage = fileSizeMB.toFixed(2)
          const totalUsedPers = ((100 * totalUsedStorage) / totalStorage)
          if (totalUsedPers >= 90) {
            this.showStorageErr = true
          } else {
            this.showStorageErr = false
          }
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        },
        () => {
          this.$store.dispatch('SetLoader', {status: false, message: ''})
        }
      )
    },
    resizeWindowHandler() {
      if (window.innerWidth < 1024) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
      if (window.innerWidth < 438) {
        this.extraSmall = true;
      } else {
        this.extraSmall = false;
      }
      this.searchWidth = window.innerWidth - 400
    }
  },
  beforeDestroy() {
    this.$root.$off('closeGlobalSearchDialog')
    this.$root.$off("custSearchingCount");
    this.$root.$off("jobSearchingCount");
    this.$root.$off("paymentSearchingCount");
    this.$root.$off("shiftSearchingCount");
    this.$root.$off("invoiceSearchingCount");
    this.$root.$off("quotesSearchingCount");
    this.$root.$off("taskSearchingCount");
    this.$root.$off("requestSearchingCount");
    this.$root.$off("visitSearchingCount");
    this.$root.$off("leadSearchingCount");
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
<style scoped>
.topAlert {
  z-index: 2;
  width: 100%;
  font-size: 14px;
}
@media screen and (max-width: 1040px) {
 .topAlert {
  font-size: 12px;
 }
}
@media screen and (max-width: 700px) {
 .topAlert {
  font-size: 10px;
 }
}
@media screen and (max-width: 450px) {
 .topAlert {
  font-size: 8px;
 }
}

.d_icon_child {
  position: relative;
}

.tooltiptext {
  visibility: hidden;
  width: 150px;
  color: #fff;
  text-align: center;
  padding: 0px 0px;
  background-color: #0000009c;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: -30px;
  left: -40px;
}


.d_icon_child:hover .tooltiptext {
  visibility: visible;
}
</style>